export const env = {
  version: process.env.AWS_COMMIT_ID || 'local',
};

export default (_, inject) => {
  inject('env', env);
};
